import React from "react";
// import is from "is_js";
import PropTypes from "prop-types";
import BaseButton from "../BaseButton";
import BaseIcon from "../BaseIcon";
import "./style.scss";

export default function BaseGameActionButton({
  type,
  onClick,
  className,
  isNegative,
  isPositive,
  isNeutral,
  to,
  disabled,
  prevAnswer,
}) {
  const icons_alias = {
    negative: "close_cross",
    positive: "checked",
    question: "question",
    back: "left_arrow",
    forward: "right_arrow",
    up: "up_arrow",
    down: "down_arrow",
  };
  BaseGameActionButton.propTypes = {
    type: PropTypes.string,
    isNegative: PropTypes.bool,
    isPositive: PropTypes.bool,
    isNeutral: PropTypes.bool,
    className: PropTypes.string,
    onClick: PropTypes.func,
    to: PropTypes.string,
    disabled: PropTypes.bool,
    prevAnswer: PropTypes.number,
  };
  const cls = ["game-action-btn"];
  const icCls = [];
  if (isPositive) {
    cls.push("active-action positive-background");
    icCls.push("active-action-icon");
  }
  if (isNegative) {
    cls.push("active-action negative-background");
    icCls.push("active-action-icon");
  }
  if (isNeutral) {
    cls.push("active-action neutral-background");
    icCls.push("active-action-icon");
  }
  if (className) cls.push(className);

  const directionalTypes = ["back", "forward", "up", "down"];
  if (directionalTypes.some((directionalType) => directionalType === type)) {
    cls.push("game-action-btn__direction");
    icCls.push("game-action-btn__direction__icon");
    // if (is.mobile()) {
    //   cls.push("game-action-btn__direction__mobile-safari");
    //   icCls.push("game-action-btn__direction__mobile-safari__icon");
    // }
  }
  if (type === "negative") {
    cls.push("game-action-btn__negative");
    icCls.push("game-action-btn__negative__icon");
    // if (is.mobile()) {
    //   cls.push("game-action-btn__negative__mobile-safari");
    //   icCls.push("game-action-btn__negative__mobile-safari__icon");
    // }
    if (prevAnswer === 3) {
      cls.push("negative-hover");
      icCls.push("negative-hover__icon");
    }
  }
  if (type === "positive") {
    cls.push("game-action-btn__positive");
    icCls.push("game-action-btn__positive__icon");
    // if (is.mobile()) {
    //   cls.push("game-action-btn__positive__mobile-safari");
    //   icCls.push("game-action-btn__positive__mobile-safari__icon");
    // }
    if (prevAnswer === 1) {
      cls.push("positive-hover");
      icCls.push("positive-hover__icon");
    }
  }

  if (type === "question") {
    cls.push("game-action-btn__question");
    icCls.push("game-action-btn__question__icon");
    // if (is.mobile()) {
    //   cls.push("game-action-btn__question__mobile-safari");
    //   icCls.push("game-action-btn__question__mobile-safari__icon");
    // }
    if (prevAnswer === 2) {
      cls.push("neutral-hover");
      icCls.push("neutral-hover__icon");
    }
  }
  return (
    <BaseButton
      to={to}
      name={type}
      disabled={disabled}
      onClick={onClick}
      className={cls.join(" ")}
    >
      <BaseIcon name={icons_alias[type]} className={icCls.join(" ")} />
    </BaseButton>
  );
}
